import { render, staticRenderFns } from "./BdSplit.vue?vue&type=template&id=0e16da44&"
import script from "./BdSplit.vue?vue&type=script&lang=js&"
export * from "./BdSplit.vue?vue&type=script&lang=js&"
import style0 from "./BdSplit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports